import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FileUploadConfig } from '~/uploads/constants';
import { getCardSizes } from '~/shared-components/Carousel';
import { getCardsToShow, sortCards } from '../../../utils/Carousel';
import CardDragWrapper from '../CardDragWrapper';
import CardItem from '../CardItem';

const CarouselCards = ({
  totalCardsToShow,
  largeCards,
  editMode,
  cards,
  uploadDraftFile,
  monitorUpdateProgress,
  createNewFile,
  createImageThumbnail,
  uploadImageComplete,
  onAddNoteClick,
  onDeleteStoryClick,
  onDropCard,
  notifiers,
}) => {
  const translations = useSelector(
    (state) => state.i18n.translations['story-group-composer']
  );
  const cardsToRender = editMode
    ? getCardsToShow({ cards, totalCardsToShow })
    : sortCards(cards);
  const { cardWidth, cardHeight } = getCardSizes(largeCards);
  const maxAttachableMediaCount = totalCardsToShow - cards.length;
  const uploadFormatsConfig = new Map(FileUploadConfig.STORIES); // Clone config

  return cardsToRender.map((card, index) => (
    <CardDragWrapper
      index={index}
      key={card.uploadTrackingId}
      card={card}
      largeCards={largeCards}
      cardHeight={cardHeight}
      cardWidth={cardWidth}
      onAddNoteClick={onAddNoteClick}
      onDeleteStoryClick={onDeleteStoryClick}
      maxAttachableMediaCount={maxAttachableMediaCount}
      uploadDraftFile={uploadDraftFile}
      monitorUpdateProgress={monitorUpdateProgress}
      createNewFile={createNewFile}
      createImageThumbnail={createImageThumbnail}
      uploadImageComplete={uploadImageComplete}
      editMode
      uploadFormatsConfig={uploadFormatsConfig}
      cardLimit={totalCardsToShow}
      totalCards={cards.length}
      onDropCard={onDropCard}
      translations={translations}
      notifiers={notifiers}
    />
  ));
};

CarouselCards.propTypes = {
  cards: PropTypes.arrayOf(CardItem.propTypes.card),
  largeCards: PropTypes.bool.isRequired,
  onAddNoteClick: PropTypes.func.isRequired,
  onDeleteStoryClick: PropTypes.func.isRequired,
};

export default CarouselCards;
